import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/**
 * Component que a traves de un array de Allergens muestra su icona
 *
 * Paso a crear:
 * Poder escoger el tamaño del icono
 */

@Component({
  selector: 'comp-weather',
  templateUrl: 'weather.html',
})
export class WeatherPage {
  @Input() weather;
  @Input() size: number = 6;

  constructor(public navCtrl: NavController, public navParams: NavParams) {

  }

  styleIcon() {
    let styles = {
      'font-size': this.size + 'rem',
      'width': '0em',
      'height': '3em',
      'margin-bottom': '20px',
    };

    return styles;

  }
}



// WEBPACK FOOTER //
// ./src/pages/components/weather/weather.ts